import { render, staticRenderFns } from "./MultiOrderableDocumentKindListSelectorDialog.vue?vue&type=template&id=0421d1e4&scoped=true&"
import script from "./MultiOrderableDocumentKindListSelectorDialog.vue?vue&type=script&lang=ts&"
export * from "./MultiOrderableDocumentKindListSelectorDialog.vue?vue&type=script&lang=ts&"
import style0 from "./MultiOrderableDocumentKindListSelectorDialog.vue?vue&type=style&index=0&id=0421d1e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0421d1e4",
  null
  
)

export default component.exports